// extracted by mini-css-extract-plugin
module.exports = {"table":"styles_table__3eEIT","table-body":"styles_table-body__z0fNK","resized":"styles_resized__2sASA","address":"styles_address__3m1Xo","state":"styles_state__2M7g4"};